import React, { Fragment } from 'react';
import { Check } from 'lucide-react';
import {
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from '@dashboard/components/ui/dropdown-menu';
import PickerItemIcon from './PickerItemIcon';
import ConditionalBranchIcon, { TRIGGER_LABEL } from './ConditionalBranchIcon';
import { startsListGroup } from './pickerItems';

/** The picker as menu items, for phones, where the two-pane dialog does not fit. */
export default function PickerMenuItems({ sections, onPick, selectedId }) {
  return sections.map((section, index) => (
    <Fragment key={section.title}>
      {index > 0 && <DropdownMenuSeparator />}
      <DropdownMenuLabel className="text-xs font-medium text-muted-foreground">
        {section.title}
      </DropdownMenuLabel>
      {section.items.map((item, index) => (
        <Fragment key={item.id}>
          {startsListGroup(section.items, index) && <DropdownMenuSeparator />}
          <DropdownMenuItem disabled={Boolean(item.disabledReason)} onSelect={() => onPick(item)}>
            <PickerItemIcon item={item} />
            <span className="truncate">{item.label}</span>
            {item.disabledReason ? (
              <span className="ml-auto text-xs">{item.disabledReason}</span>
            ) : item.id === selectedId ? (
              <Check className="ml-auto" aria-label="Current type" />
            ) : (
              item.trigger && (
                <span title={TRIGGER_LABEL} className="ml-auto text-muted-foreground/80">
                  <ConditionalBranchIcon />
                </span>
              )
            )}
          </DropdownMenuItem>
        </Fragment>
      ))}
    </Fragment>
  ));
}
